import util from '../util'

let controller = 'ProtegeMais'

export default Object.assign({}, util.GetCrud(controller, []), {
  listar: function () {
    return util.Axios.Get(controller)
  },
  obterArquivo: function (codigo) {
    return util.Axios.Get(controller + `/${codigo}`)
  }
})
